import styled from '@emotion/styled';

export const SuggestedResponseContainer = styled('div')`
  max-width: 37rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  margin-top: 1.3rem;
  padding: 0 1rem;
  border-radius: 4px;
  border: 1px solid #ddd;
  transition: all 0.3s ease;
  &:hover {
    border-color: black;
    border-radius: 4px;
  }
  &:focus-within {
    border-color: #029dff;
    border-radius: 4px;
  }
  label {
    font-size: 1rem;
    top: -1rem;
    left: 0.9rem;
    padding: 0 0.3rem;
    position: absolute;
    background: white;
  }
  input {
    border: none;
    margin: 0.3rem;
  }
  input:focus {
    outline: none;
  }
  p {
    margin-right: 1rem;
  }
`;

export const SuggestedResponseButtonContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: flex-start;
  flex-grow: 1;
  width: 90%;
  min-height: 4rem;
  span {
    color: rgba(51, 51, 51, 0.5);
    letter-spacing: 0.1rem;
  }
  button {
    padding: 0;
    justify-content: space-between;
    text-transform: none;
    display: flex;
    align-items: center;
    padding-left: 1rem;
    padding-right: 0.5rem;
    margin-right: 0.5rem;
    min-width: 3rem;
    font-weight: normal;
    p {
      max-width: 20rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      line-height: 1.5;
    }
    svg {
      height: 2rem;
      width: 2rem;
    }
  }
`;
export const ErrorMessage = styled('div')`
  color: red;
  padding: 0.5rem;
`;
